export const NotaFiscalModais = {
  buscaAvancada: 'buscaAvancada',
};
